// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609240845/js/" + chunkId + "." + {"44":"49997530","225":"99589260","481":"66469469","486":"bc49ea12","770":"d685e60f"}[chunkId] + ".0.4116515433227641.chunk.js";
};